export const CONSIGNEE_ADDRESS_VALIDITY_CHECK_KEY = 'consigneeAddressValid';
export const BILLING_ADDRESS_VALIDITY_CHECK_KEY = 'billingAddressValid';
export const SHIPPING_ADDRESS_VALIDITY_CHECK_KEY = 'shippingAddressValid';
export const TAX_ID_PRESENT_VALIDITY_CHECK_KEY = 'taxIdIsPresent';
